import { render, staticRenderFns } from "./Shipings.vue?vue&type=template&id=3eb94af5"
import script from "./Shipings.vue?vue&type=script&lang=js"
export * from "./Shipings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports